var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _vm.initialized
      ? _c(
          "div",
          { staticClass: "content", attrs: { id: "activityList" } },
          [
            _c("summarybar", {
              attrs: {
                totalslots: _vm.result.totalSlots,
                total: _vm.result.total,
                open: _vm.result.open,
                registered: _vm.result.registered,
                double: _vm.doubleattendant,
              },
            }),
            _vm._v(" "),
            _vm._l(_vm.result.activties, function (item) {
              return [
                item.activityPeriods == null || item.activityPeriods.length == 0
                  ? _c(
                      "article",
                      {
                        staticClass: "activity",
                        class:
                          item.attendants.length > 0 &&
                          _vm.isDoubleUser(item, false)
                            ? "error"
                            : "",
                      },
                      [
                        _c("div", { staticClass: "activity-header" }, [
                          _c("div", [
                            _c(
                              "h3",
                              {
                                staticClass: "cursorpointer",
                                on: {
                                  click: function ($event) {
                                    return _vm.openactivity(item.id)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(item.title))]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "activity-meta" }, [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.getDate(item.startTime)) +
                                    "–" +
                                    _vm._s(_vm.getDate(item.endTime))
                                ),
                              ]),
                              _c("span", [_vm._v(_vm._s(item.location))]),
                              _c("span", [
                                _vm._v(
                                  _vm._s(item.requireSupervisor) +
                                    " " +
                                    _vm._s(_vm.$t("supervisorneed"))
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "requirements" },
                              _vm._l(
                                item.educationQualifications,
                                function (qualification) {
                                  return _c(
                                    "span",
                                    { staticClass: "tag required" },
                                    [_vm._v(_vm._s(qualification.description))]
                                  )
                                }
                              ),
                              0
                            ),
                          ]),
                          _vm._v(" "),
                          item.attendants.length > 0 &&
                          _vm.isDoubleUser(item, false)
                            ? _c("span", { staticClass: "status bad" }, [
                                _vm._v(" " + _vm._s(_vm.$t("doubleattendant"))),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "grid" }, [
                          _c("div", { staticClass: "cell" }, [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(_vm._s(_vm.$t("registeredclient"))),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "youth-line" },
                              [
                                _vm._l(
                                  item.registeredClients,
                                  function (client) {
                                    return [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "youth-name",
                                          attrs: {
                                            "data-youth-activity": "academie",
                                          },
                                        },
                                        [_vm._v(_vm._s(client.fullName))]
                                      ),
                                    ]
                                  }
                                ),
                              ],
                              2
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "cell" }, [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(_vm._s(_vm.$t("availablesupervisor"))),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "persons" },
                              [
                                _vm._l(
                                  item.availableSupervisors,
                                  function (attendant) {
                                    return [
                                      _c(
                                        "span",
                                        { staticClass: "person available" },
                                        [
                                          _vm._v(_vm._s(attendant.fullName)),
                                          _c("em", [
                                            _vm._v(
                                              _vm._s(
                                                attendant.contractType == 0
                                                  ? _vm.$t("contract")
                                                  : _vm.$t("aangemeld")
                                              ) + " "
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  }
                                ),
                              ],
                              2
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "cell" }, [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(_vm._s(_vm.$t("aspercontract"))),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "persons" },
                              [
                                _vm._l(item.attendants, function (attendant) {
                                  return [
                                    _c(
                                      "span",
                                      { staticClass: "person contract" },
                                      [
                                        _vm._v(_vm._s(attendant.fullName)),
                                        _c("em", [
                                          _vm._v(
                                            _vm._s(
                                              attendant.contractType == 0
                                                ? _vm.$t("contract")
                                                : _vm.$t("aangemeld")
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                }),
                              ],
                              2
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "cell" },
                            [
                              _c("div", { staticClass: "label" }, [
                                _vm._v(_vm._s(_vm.$t("scheduled"))),
                              ]),
                              _vm._v(" "),
                              _c(
                                "draggable",
                                {
                                  staticClass: "drop-area",
                                  attrs: {
                                    "item-key": item.id,
                                    group: {
                                      name: "users",
                                      pull: false,
                                      put: true,
                                    },
                                  },
                                  on: {
                                    add: function ($event) {
                                      return _vm.checkMove($event, item)
                                    },
                                    change: _vm.onChange,
                                  },
                                  model: {
                                    value: item.attendants,
                                    callback: function ($$v) {
                                      _vm.$set(item, "attendants", $$v)
                                    },
                                    expression: "item.attendants",
                                  },
                                },
                                [
                                  _vm._l(item.attendants, function (attendant) {
                                    return [
                                      _c(
                                        "span",
                                        {
                                          key: attendant.id,
                                          staticClass: "person available",
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(attendant.fullName)
                                          ),
                                          _c("em", [
                                            _vm._v(
                                              _vm._s(
                                                attendant.contractType == 0
                                                  ? _vm.$t("contract")
                                                  : _vm.$t("aangemeld")
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "remove remove-assignment",
                                              attrs: {
                                                "data-item": "avond20",
                                                "data-staff": "sterre",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.deleteAttendant(
                                                    attendant.id,
                                                    0,
                                                    item.id
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("×")]
                                          ),
                                        ]
                                      ),
                                    ]
                                  }),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "add open-picker",
                                  attrs: { "data-item": "academie" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.addsupervisor(item)
                                    },
                                  },
                                },
                                [_vm._v("+ " + _vm._s(_vm.$t("addsupervisor")))]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "cell" }, [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(_vm._s(_vm.$t("checks"))),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "checks" },
                              [
                                _vm._l(
                                  item.educationQualifications,
                                  function (edu) {
                                    return [
                                      item.attandantEducationQualifications.some(
                                        (x) => x == edu.id
                                      )
                                        ? _c(
                                            "div",
                                            { staticClass: "check ok" },
                                            [
                                              _c("b", [_vm._v("✓")]),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(_vm._s(edu.description)),
                                              ]),
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            { staticClass: "check bad" },
                                            [
                                              _c("b", [_vm._v("!")]),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(_vm._s(edu.description)),
                                              ]),
                                            ]
                                          ),
                                    ]
                                  }
                                ),
                                _vm._v(" "),
                                item.attendants.length > 0 &&
                                _vm.isDoubleUser(item, false)
                                  ? _c("div", { staticClass: "check bad" }, [
                                      _c("b", [_vm._v("!")]),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          " " + _vm._s(_vm.$t("dualsupervisor"))
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ]),
                        ]),
                      ]
                    )
                  : _c(
                      "article",
                      {
                        staticClass: "activity",
                        class: _vm.isDoubleAttedant(item) ? "error" : "",
                      },
                      [
                        _c("div", { staticClass: "activity-header" }, [
                          _c("div", [
                            _c("h3", [_vm._v(_vm._s(item.title))]),
                            _vm._v(" "),
                            _c("div", { staticClass: "activity-meta" }, [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.getDate(item.startTime)) +
                                    " → " +
                                    _vm._s(_vm.getDate(item.endTime))
                                ),
                              ]),
                              _c("span", [_vm._v(_vm._s(item.location))]),
                              _c("span", [
                                _vm._v(
                                  _vm._s(item.registeredClients.length) +
                                    " " +
                                    _vm._s(_vm.$t("client"))
                                ),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm.isDoubleAttedant(item)
                            ? _c("span", { staticClass: "status bad" }, [
                                _vm._v(" " + _vm._s(_vm.$t("doubleattendant"))),
                              ])
                            : _c("span", { staticClass: "status warn" }, [
                                _vm._v(
                                  _vm._s(item.openSlots) +
                                    " " +
                                    _vm._s(_vm.$t("open"))
                                ),
                              ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "logeren-top" }, [
                          _c("div", { staticClass: "logeren-info" }, [
                            _c("strong", [_vm._v(_vm._s(item.title))]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.getDate(item.startTime)) +
                                  " → " +
                                  _vm._s(_vm.getDate(item.endTime))
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("youngpeoplequalifyforservices"))
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "logeren-youth" }, [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(_vm._s(_vm.$t("registeredclient"))),
                            ]),
                            _c(
                              "div",
                              { staticClass: "youth-line" },
                              [
                                _vm._l(
                                  item.registeredClients,
                                  function (client) {
                                    return [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "youth-name",
                                          attrs: {
                                            "data-youth-activity": "academie",
                                          },
                                        },
                                        [_vm._v(_vm._s(client.fullName))]
                                      ),
                                    ]
                                  }
                                ),
                              ],
                              2
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "service-row header" }, [
                          _c("div", [_vm._v(_vm._s(_vm.$t("employee")))]),
                          _vm._v(" "),
                          _c("div", [_vm._v(_vm._s(_vm.$t("available")))]),
                          _vm._v(" "),
                          _c("div", [_vm._v(_vm._s(_vm.$t("contract")))]),
                          _vm._v(" "),
                          _c("div", [_vm._v(_vm._s(_vm.$t("scheduled")))]),
                          _vm._v(" "),
                          _c("div", [_vm._v(_vm._s(_vm.$t("checks")))]),
                        ]),
                        _vm._v(" "),
                        _vm._l(item.activityPeriods, function (period) {
                          return [
                            _c("div", { staticClass: "service-row" }, [
                              _c("div", { staticClass: "service-name" }, [
                                _c("strong", [_vm._v(_vm._s(period.title))]),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.getDate(period.startTime)) +
                                      "–" +
                                      _vm._s(_vm.getDate(period.endTime))
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _c(
                                  "div",
                                  { staticClass: "persons" },
                                  [
                                    _vm._l(
                                      item.availableSupervisors,
                                      function (attendant) {
                                        return [
                                          _c(
                                            "span",
                                            { staticClass: "person available" },
                                            [
                                              _vm._v(
                                                _vm._s(attendant.fullName)
                                              ),
                                              _c("em", [
                                                _vm._v(
                                                  _vm._s(
                                                    attendant.contractType == 0
                                                      ? _vm.$t("contract")
                                                      : _vm.$t("aangemeld")
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      }
                                    ),
                                  ],
                                  2
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _c(
                                  "div",
                                  { staticClass: "persons" },
                                  [
                                    _vm._l(
                                      period.attendants,
                                      function (attendant) {
                                        return [
                                          _c(
                                            "span",
                                            { staticClass: "person contract" },
                                            [
                                              _vm._v(
                                                _vm._s(attendant.fullName)
                                              ),
                                              _c("em", [
                                                _vm._v(
                                                  _vm._s(
                                                    attendant.contractType == 0
                                                      ? _vm.$t("contract")
                                                      : _vm.$t("aangemeld")
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      }
                                    ),
                                  ],
                                  2
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _c(
                                  "div",
                                  {
                                    staticClass: "dropzonenew",
                                    attrs: { "data-drop-item": "avond20" },
                                  },
                                  [
                                    _c(
                                      "draggable",
                                      {
                                        staticClass: "drop-area",
                                        attrs: {
                                          "item-key": period.id,
                                          group: {
                                            name: "users",
                                            pull: false,
                                            put: true,
                                          },
                                        },
                                        on: {
                                          add: function ($event) {
                                            return _vm.checkMove($event, period)
                                          },
                                          change: _vm.onChange,
                                        },
                                        model: {
                                          value: period.attendants,
                                          callback: function ($$v) {
                                            _vm.$set(period, "attendants", $$v)
                                          },
                                          expression: "period.attendants",
                                        },
                                      },
                                      [
                                        _vm._l(
                                          period.attendants,
                                          function (attendant) {
                                            return [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "person contract",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                            " +
                                                      _vm._s(attendant.fullName)
                                                  ),
                                                  _c("em", [
                                                    _vm._v(
                                                      _vm._s(
                                                        attendant.contractType ==
                                                          0
                                                          ? _vm.$t("contract")
                                                          : _vm.$t("aangemeld")
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "remove remove-assignment",
                                                      attrs: {
                                                        "data-item": "avond20",
                                                        "data-staff": "sterre",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.deleteAttendant(
                                                            attendant.id,
                                                            period.activityPeriodId,
                                                            period.id
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("×")]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "add open-picker",
                                    attrs: { "data-item": "avond20" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.addsupervisor(period)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "+ " + _vm._s(_vm.$t("addsupervisor"))
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _c(
                                  "div",
                                  { staticClass: "checks" },
                                  [
                                    _vm._l(
                                      item.educationQualifications,
                                      function (edu) {
                                        return [
                                          period.attandantEducationQualifications.some(
                                            (x) => x == edu.id
                                          )
                                            ? _c(
                                                "div",
                                                { staticClass: "check ok" },
                                                [
                                                  _c("b", [_vm._v("✓")]),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(edu.description)
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            : _c(
                                                "div",
                                                { staticClass: "check bad" },
                                                [
                                                  _c("b", [_vm._v("!")]),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(edu.description)
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                        ]
                                      }
                                    ),
                                    _vm._v(" "),
                                    period.attendants.length > 0 &&
                                    _vm.isDoubleUser(period, true)
                                      ? _c(
                                          "div",
                                          { staticClass: "check bad" },
                                          [
                                            _c("b", [_vm._v("!")]),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("dualsupervisor")
                                                  )
                                              ),
                                            ]),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                              ]),
                            ]),
                          ]
                        }),
                      ],
                      2
                    ),
              ]
            }),
          ],
          2
        )
      : _c("div", [_c("spinner")], 1),
    _vm._v(" "),
    _c("div", { staticClass: "audit" }, [
      _c("h3", [_vm._v("Wijzigingen en overrides")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "audit-log", attrs: { id: "auditLog" } },
        _vm._l(_vm.overridies, function (item) {
          return item.warning
            ? _c("div", { staticClass: "audit-item" }, [
                _vm._v(_vm._s(item.warning)),
              ])
            : _vm._e()
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }